// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hbIez","linkBlock":"styles_linkBlock__cMRDV"};